import React from "react";
import {SalesSummaryPackage} from "./SalesSummaryPackage";
import {SalesPackageOption} from "../SalesPackageOption";
import {VehicleGroup} from "../../../model/vehicle";
import {strings} from "../../../strings/strings";
import {sumInsuredFormat} from "../../../utils/format";
import {isSmartDrive} from "../../../utils/quotation";
import useSwitchToNewContent from "../../../utils/hooks/useSwitchToNewContent";

interface MTPLSummaryPackage {
    vehicleGroup: VehicleGroup;
    premium: number;
    deductible: number;
    vtplAdditionalCoverage: number;
    mtplContract: number;
    tarrificationProgram: string;
}

export const MTPLSummaryPackage = (props: MTPLSummaryPackage) => {
    const {mtplContract, deductible, vtplAdditionalCoverage, vehicleGroup, premium, tarrificationProgram} = props;
    const showNewContent = useSwitchToNewContent()

    const initOptions = () => {
        const options = [
            <SalesPackageOption name={strings.packageOptionMtplName}
                                tooltipPlacement={"left"}
                                tooltip={<ul>
                                  <li>{showNewContent ? strings.packageOptionMtplText1in2025 : strings.packageOptionMtplText1}</li>
                                  <li>{showNewContent ? strings.packageOptionMtplText2in2025 : strings.packageOptionMtplText2}</li>
                                </ul>}
                                covered={true}
                                key={"option1"}
                                price={mtplContract}/>,
            <SalesPackageOption name={`${strings.franchise} ${sumInsuredFormat(deductible)} ${strings.currencyUAH}`}
                                covered={true} key={"option2"}
                                tooltipPlacement={"left"}
                                tooltip={<div><span
                                className={"accent"}>{strings.franchise2}</span>{strings.franchiseDescription}</div>}
                                />,
        ];

        if (vtplAdditionalCoverage) {
            options.push(<SalesPackageOption name={strings.packageOptionVtplName}
                                             covered={true}
                                             price={vtplAdditionalCoverage}/>);
        }

        return options;
    };

    return (
        <SalesSummaryPackage
            vehicleGroup={vehicleGroup}
            name={isSmartDrive(tarrificationProgram) ? strings.smartDrive.packageBaseName : strings.packageMtplName}
            premium={premium}
            tarrificationProgram={tarrificationProgram}
            options={initOptions()}/>
    )
};